export default {
    'sex.male': 'Male',
    'sex.female': 'Female',
    'sex.other': 'Other',
    'sex.unknown': 'Unknown',
    'invoice_status.draft': 'Estimate',
    'invoice_status.issued': 'Unpaid',
    'invoice_status.partially_paid': 'Partially paid',
    'invoice_status.paid': 'Paid',
    'invoice_status.cancelled': 'Cancelled',
    'invoice_status.refunded': 'Refunded',
    'payment_mode.cash': 'Cash',
    'payment_mode.card': 'Card',
    'payment_mode.bank_transfer': 'Bank transfer',
    'payment_mode.mobile_wallet': 'Mobile wallet',
    'payment_mode.cheque': 'Cheque',
    'tax_category.standard': 'Standard rated',
    'tax_category.zero': 'Zero rated',
    'tax_category.exempt': 'Exempt',
    'tax_category.out_of_scope': 'Outside the scope of tax',
    'id_missing_reason.unidentified': 'Unidentified',
    'id_missing_reason.newborn': 'Newborn',
    'id_missing_reason.not_held': 'Does not hold a document',
    'id_missing_reason.refused': 'Declined to show one',
    'patient_category.general': 'General',
    'patient_category.panel': 'Panel',
    'patient_category.insurance': 'Insurance',
    'patient_category.staff': 'Staff',
    'patient_category.charity': 'Charity',
    'patient_category.vip': 'VIP',
    'appointment_status.booked': 'Booked',
    'appointment_status.arrived': 'Arrived',
    'appointment_status.in_consultation': 'With the doctor',
    'appointment_status.completed': 'Completed',
    'appointment_status.cancelled': 'Cancelled',
    'appointment_status.no_show': 'Did not come',
    'appointment_status.confirmed': 'Confirmed',
    'encounter_status.open': 'Open',
    'encounter_status.closed': 'Closed',
    'prescription_status.issued': 'Issued',
    'prescription_status.partially_dispensed': 'Partially dispensed',
    'prescription_status.dispensed': 'Dispensed',
    'prescription_status.cancelled': 'Cancelled',
    'clinical_order_status.ordered': 'Ordered',
    'clinical_order_status.in_progress': 'In progress',
    'clinical_order_status.completed': 'Completed',
    'clinical_order_status.cancelled': 'Cancelled',
    'admission_status.admitted': 'Admitted',
    'admission_status.discharged': 'Discharged',
    'admission_status.lama': 'Left against medical advice',
    'admission_status.referred': 'Referred',
    'admission_status.expired': 'Expired',
    'admission_status.absconded': 'Absconded',
    'bed_status.vacant': 'Vacant',
    'bed_status.occupied': 'Occupied',
    'bed_status.reserved': 'Reserved',
    'bed_status.cleaning': 'Cleaning',
    'bed_status.blocked': 'Blocked',
    'lab_status.ordered': 'Ordered',
    'lab_status.collected': 'Collected',
    'lab_status.received': 'Received',
    'lab_status.rejected': 'Rejected',
    'lab_status.in_process': 'In process',
    'lab_status.resulted': 'Resulted',
    'lab_status.verified': 'Verified',
    'lab_status.released': 'Released',
    'lab_status.cancelled': 'Cancelled',
    'lab_flag.normal': 'Normal',
    'lab_flag.low': 'Low',
    'lab_flag.high': 'High',
    'lab_flag.abnormal': 'Abnormal',
    'lab_flag.no_range': 'No range',
    'lab_flag.critical_low': 'Critical low',
    'lab_flag.critical_high': 'Critical high',
    'radiology_status.ordered': 'Ordered',
    'radiology_status.scheduled': 'Scheduled',
    'radiology_status.arrived': 'Arrived',
    'radiology_status.scanned': 'Scanned',
    'radiology_status.reported': 'Reported',
    'radiology_status.verified': 'Verified',
    'radiology_status.released': 'Released',
    'radiology_status.cancelled': 'Cancelled',
    'claim_status.draft': 'Draft',
    'claim_status.submitted': 'Submitted',
    'claim_status.queried': 'Queried',
    'claim_status.approved': 'Approved',
    'claim_status.partially_paid': 'Partially paid',
    'claim_status.paid': 'Paid',
    'claim_status.rejected': 'Rejected',
    'claim_status.cancelled': 'Cancelled',
    'refund_status.requested': 'Requested',
    'refund_status.approved': 'Approved',
    'refund_status.paid': 'Paid',
    'refund_status.rejected': 'Rejected',
    'payment_status.pending': 'Pending',
    'payment_status.completed': 'Completed',
    'payment_status.failed': 'Failed',
    'payment_status.reverted': 'Reverted',
    'indent_status.requested': 'Requested',
    'indent_status.approved': 'Approved',
    'indent_status.issued': 'Issued',
    'indent_status.partially_issued': 'Partially issued',
    'indent_status.rejected': 'Rejected',
    'purchase_order_status.draft': 'Draft',
    'purchase_order_status.submitted': 'Submitted',
    'purchase_order_status.partially_received': 'Partially received',
    'purchase_order_status.received': 'Received',
    'purchase_order_status.cancelled': 'Cancelled',
    'purchase_order_status.closed': 'Closed',
    'invoice_context.opd': 'OPD',
    'invoice_context.ipd': 'IPD',
    'invoice_context.pharmacy': 'Pharmacy',
    'invoice_context.lab': 'Laboratory',
    'invoice_context.radiology': 'Radiology',
    'invoice_context.er': 'Emergency',
    'payment_mode.credit_panel': 'Panel credit',
    'payment_mode.online_gateway': 'Online payment',
    'payment_mode.deposit': 'Advance applied',
    'medication_admin.due': 'Due',
    'medication_admin.given': 'Given',
    'medication_admin.missed': 'Missed',
    'medication_admin.held': 'Held',
    'medication_admin.refused': 'Refused',
    'account_type.asset': 'Asset',
    'account_type.liability': 'Liability',
    'account_type.equity': 'Equity',
    'account_type.income': 'Income',
    'account_type.expense': 'Expense',
    'lab_result_type.numeric': 'Numeric',
    'lab_result_type.text': 'Text',
    'lab_result_type.select': 'Pick from a list',
    'lab_result_type.culture': 'Culture',
    'relation.self': 'Self',
    'relation.spouse': 'Spouse',
    'relation.child': 'Child',
    'relation.parent': 'Parent',
    'relation.sibling': 'Sibling',
    'payer_kind.corporate': 'Corporate',
    'payer_kind.government': 'Government',
    'payer_kind.ngo': 'NGO',
    'preauth_status.partially_approved': 'Partially approved',
    'preauth_status.expired': 'Expired',
    'count_period.visit': 'Visit',
    'count_period.year': 'Year',
    'priority.routine': 'Routine',
    'priority.urgent': 'Urgent',
    'priority.stat': 'STAT',
    'priority.emergency': 'Emergency',
    'priority.critical': 'Critical',
    'arrival_mode.walk_in': 'Walk-in',
    'arrival_mode.ambulance': 'Ambulance',
    'arrival_mode.police': 'Police',
    'arrival_mode.referral': 'Referral',
    'delivery_mode.normal': 'Normal',
    'delivery_mode.assisted': 'Assisted',
    'delivery_mode.caesarean': 'Caesarean',
    'delivery_mode.vacuum': 'Vacuum',
    'delivery_mode.forceps': 'Forceps',
    'delivery_outcome.live_birth': 'Live birth',
    'delivery_outcome.still_birth': 'Stillbirth',
    'delivery_outcome.neonatal_death': 'Neonatal death',
    'delivery_outcome.abortion': 'Abortion',
    'liquor.intact': 'Intact',
    'liquor.clear': 'Clear',
    'liquor.meconium': 'Meconium',
    'liquor.blood_stained': 'Blood-stained',
    'liquor.absent': 'Absent',
    'anesthesia_type.general': 'General',
    'anesthesia_type.spinal': 'Spinal',
    'anesthesia_type.local': 'Local',
    'anesthesia_type.regional': 'Regional',
    'anesthesia_type.sedation': 'Sedation',
    'note_kind.progress': 'Progress',
    'note_kind.handover': 'Handover',
    'note_kind.care_plan': 'Care plan',
    'note_kind.incident': 'Incident',
    'shift.morning': 'Morning',
    'shift.evening': 'Evening',
    'shift.night': 'Night',
    'contract_type.permanent': 'Permanent',
    'contract_type.contract': 'Contract',
    'contract_type.visiting': 'Visiting',
    'contract_type.intern': 'Intern',
    'contract_type.daily_wage': 'Daily wage',
    'requester_type.patient': 'Patient',
    'requester_type.relative': 'Relative',
    'requester_type.legal': 'Legal',
    'requester_type.insurer': 'Insurer',
    'requester_type.internal': 'Internal',
    'ticket_status.escalated': 'Escalated',
    'ticket_status.resolved': 'Resolved',
    'report_aggregate.count': 'Count',
    'report_aggregate.sum': 'Sum',
    'report_aggregate.avg': 'Average',
    'report_aggregate.min': 'Minimum',
    'report_aggregate.max': 'Maximum',
    'department_kind.clinical': 'Clinical',
    'department_kind.diagnostic': 'Diagnostic',
    'department_kind.support': 'Support',
    'department_kind.administrative': 'Administrative',
    'store_type.main_pharmacy': 'Main pharmacy',
    'store_type.er_pharmacy': 'ER pharmacy',
    'store_type.ot_pharmacy': 'OT pharmacy',
    'store_type.ward_satellite': 'Ward satellite store',
    'store_type.general_store': 'General store',
    'bed_class.general': 'General ward',
    'bed_class.semi_private': 'Semi-private',
    'bed_class.private': 'Private',
    'bed_class.deluxe': 'Deluxe',
    'bed_class.icu': 'ICU',
    'bed_class.ccu': 'CCU',
    'bed_class.nicu': 'NICU',
    'bed_class.hdu': 'HDU',
    'bed_class.isolation': 'Isolation',
    'loss_category.expired': 'Expired',
    'loss_category.damaged': 'Damaged',
    'loss_category.theft': 'Theft',
    'blood_component.whole_blood': 'Whole blood',
    'blood_component.prbc': 'Packed red cells',
    'blood_component.ffp': 'Fresh frozen plasma',
    'blood_component.platelets': 'Platelets',
    'blood_component.cryoprecipitate': 'Cryoprecipitate',
    'maintenance_kind.preventive': 'Preventive',
    'maintenance_kind.calibration': 'Calibration',
    'maintenance_kind.inspection': 'Inspection',
    'schedule_leave_reason.leave': 'Leave',
    'schedule_leave_reason.conference': 'Conference',
    'schedule_leave_reason.surgery': 'Surgery',
    'visit_type.new': 'New',
    'visit_type.follow_up': 'Follow-up',
    'task_type.transport': 'Transport',
    'task_type.sample_collection': 'Sample collection',
    'task_type.housekeeping': 'Housekeeping',
    'task_type.maintenance': 'Maintenance',
    'priority.low': 'Low',
    'priority.normal': 'Normal',
    'priority.high': 'High',
    'task_type.general': 'General',
    'antibiotic_sensitivity.sensitive': 'Sensitive',
    'antibiotic_sensitivity.intermediate': 'Intermediate',
    'antibiotic_sensitivity.resistant': 'Resistant',
    'radiology_modality.xray': 'X-ray',
    'radiology_modality.ultrasound': 'Ultrasound',
    'radiology_modality.ct': 'CT',
    'radiology_modality.mri': 'MRI',
    'radiology_modality.mammography': 'Mammography',
    'radiology_modality.fluoroscopy': 'Fluoroscopy',
    'radiology_modality.echo': 'Echo',
    'radiology_modality.ecg': 'ECG',
    'radiology_modality.eeg': 'EEG',
    'radiology_modality.endoscopy': 'Endoscopy',
    'instrument_protocol.hl7': 'HL7',
    'instrument_protocol.astm': 'ASTM',
    'instrument_protocol.image-import': 'Image import',
    'charge_category.consultation': 'Consultation',
    'charge_category.procedure': 'Procedure',
    'charge_category.bed': 'Bed',
    'charge_category.nursing': 'Nursing',
    'charge_category.ot': 'Operating theatre',
    'charge_category.package': 'Package',
    'charge_category.misc': 'Miscellaneous',
    'charge_category.room': 'Room',
    'benefit_category.diagnostics': 'Diagnostics',
    'benefit_category.medicines': 'Medicines',
    'benefit_category.inpatient': 'Inpatient',
    'benefit_category.dental': 'Dental',
    'benefit_category.optical': 'Optical',
    'benefit_category.maternity': 'Maternity',
    'payer_kind.insurance': 'Insurance',
    'relation.other': 'Other',
    'preauth_status.approved': 'Approved',
    'preauth_status.rejected': 'Rejected',
    'payment_mode.other': 'Other',
    'journal_status.posted': 'Posted',
    'remittance_status.received': 'Received',
    'remittance_status.partially_allocated': 'Partially allocated',
    'remittance_status.allocated': 'Allocated',
    'remittance_status.unmatched': 'Unmatched',
    'remittance_status.needs_review': 'Needs review',
    'remittance_status.posted': 'Applied',
    'integration_provider.nphies': 'NPHIES',
    'integration_provider.wasfaty': 'Wasfaty',
    'nphies_operation.priorauth': 'Prior authorisation',
    'nphies_operation.eligibility': 'Eligibility',
    'nphies_operation.claim': 'Claim',
    'nphies_operation.poll': 'Poll',
    'nphies_operation.cancel': 'Cancel',
    'nphies_operation.status-check': 'Status check',
    'nphies_operation.communication': 'Communication',
    'nphies_operation.payment-notice': 'Payment notice',
    'nphies_operation.eligibility-request': 'Eligibility request',
    'nphies_operation.poll-request': 'Poll request',
    'nphies_entity_type.pre_authorization': 'Pre-authorisation',
    'appointment_type.internal_referral': 'Internal referral',
    'audit_action.create': 'Created',
    'audit_action.update': 'Updated',
    'audit_action.delete': 'Deleted',
    'audit_action.view_sensitive': 'Viewed sensitive record',
    'audit_action.break_glass': 'Break-glass access',
    'audit_action.login': 'Signed in',
    'audit_action.logout': 'Signed out',
    'audit_action.export': 'Exported',
    'integration_message_status.queued': 'Queued',
    'integration_message_status.sending': 'Sending',
    'integration_message_status.succeeded': 'Succeeded',
    'integration_message_status.offline': 'Offline',
    'integration_local_type.payer': 'Insurer',
    'integration_local_type.charge_item': 'Billed service',
    'integration_local_type.product': 'Drug or product',
    'release_channel.STABLE': 'Stable',
    'release_channel.BETA': 'Beta',
    'report_mode.rows': 'Rows',
    'report_mode.grouped': 'Grouped',
    'actor_type.user': 'User',
    'watch_end_reason.owner_console': 'Ended from the owner console',
    'watch_end_reason.owner_viewer': 'Ended by the viewer',
    'watch_end_reason.user': 'Ended by the user',
    'watch_end_reason.time': 'Time ran out',
    'watch_end_reason.empty': 'Nobody joined',
    'watch_end_reason.link_lost': 'Connection lost',
    'platform_role.owner': 'Owner',
    'platform_role.platform_admin': 'Platform admin',
    'platform_role.support_agent': 'Support agent',
    'platform_role.platform_finance': 'Finance',
    'platform_role.contact_person': 'Account manager',
    'facility_type.hospital': 'Hospital',
    'facility_type.pharmacy': 'Medical store',
    'facility_request_status.submitted': 'Sent',
    'facility_request_status.approved': 'Created',
    'facility_request_status.rejected': 'Turned down',
    'facility_request_status.expired': 'Expired',
    'billing_cycle.monthly': 'Monthly',
    'billing_cycle.annual': 'Annual',
    'batch_status.active': 'Active',
    'batch_status.quarantined': 'Quarantined',
    'batch_status.recalled': 'Recalled',
    'blood_unit_status.quarantine': 'Quarantine',
    'blood_unit_status.available': 'Available',
    'blood_unit_status.transfused': 'Transfused',
    'blood_unit_status.discarded': 'Discarded',
    'blood_unit_status.expired': 'Expired',
    'tenant_environment.live': 'Live',
    'tenant_environment.demo': 'Demo',
    'tenant_export_status.running': 'Running',
    'tenant_export_status.ready': 'Ready',
    'tenant_export_status.downloaded': 'Downloaded',
    'tenant_export_status.expired': 'Expired',
    'tenant_status.trial': 'Trial',
    'tenant_status.past_due': 'Past due',
    'tenant_status.suspended': 'Suspended',
    'tenant_status.archived': 'Archived',
    'product_type.drug': 'Drug',
    'product_type.consumable': 'Consumable',
    'product_type.service_item': 'Service item',
    'stock_control_status.counted': 'Counted',
    'stock_control_status.disputed': 'Disputed',
    'therapy_unit.dialysis': 'Dialysis',
    'therapy_unit.chemotherapy': 'Chemotherapy',
    'therapy_unit.physiotherapy': 'Physiotherapy',
    'therapy_unit.day_care': 'Day care',
};
//# sourceMappingURL=enum.js.map